export enum RecallTaskRecurrence {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
}
